import React from "react";
import Chart from "react-apexcharts";
import ChartCard from "./ChartCard";
import { baseChartOptions } from "./chartTheme";

interface TestCaseDistributionProps {
  labels?: string[];
  series?: number[];
}

const CHART_ID = "test-case-distribution";

const TestCaseDistribution: React.FC<TestCaseDistributionProps> = ({
  labels = [],
  series = [],
}) => {
  const safeLabels =
    labels.length > 0 ? labels : ["SUCCESS", "FAILED", "IN_QUEUE"];
  const safeSeries = series.length > 0 ? series : [0, 0, 0];

  const base = baseChartOptions(CHART_ID);
  const options = {
    ...base,
    chart: { ...base.chart, type: "donut" },
    colors: ["#15803d", "#dc2626", "#b45309", "#2563eb", "#7c3aed"],
    labels: safeLabels,
    legend: { ...base.legend, position: "bottom" },
    plotOptions: { pie: { donut: { size: "62%" } } },
    stroke: { width: 2, colors: ["#fff"] },
  };

  return (
    <ChartCard
      title="Test Case Distribution"
      description="Displays the percentage breakdown of test cases by status."
      chartId={CHART_ID}
    >
      <Chart options={options} series={safeSeries} type="donut" height={300} />
    </ChartCard>
  );
};

export default TestCaseDistribution;
